import { render, staticRenderFns } from "./RulesIndicator.vue?vue&type=template&id=037fb347"
import script from "./RulesIndicator.vue?vue&type=script&lang=js"
export * from "./RulesIndicator.vue?vue&type=script&lang=js"
import style0 from "./RulesIndicator.vue?vue&type=style&index=0&id=037fb347&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports